import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  PrimitiveDescriptorSafe1r3pht5v1oaqu as PrimitiveDescriptorSafe,
  checkNameIsNotAPrimitive28vmhppr4nskt as checkNameIsNotAPrimitive,
} from '../internal/Primitives.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  CLASS_getInstance3jy3ydw5832xx as CLASS_getInstance,
  PrimitiveKindndgbuh6is7ze as PrimitiveKind,
} from './SerialKinds.mjs';
import {
  toList383f556t1dixk as toList,
  withIndex3s8q7w1g0hyfn as withIndex,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Arrays.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { HashSet2dzve9y63nf0v as HashSet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/HashSet.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  toHashSet1qrcsl3g8ugc8 as toHashSet,
  toBooleanArray2u3qw7fjwsmuh as toBooleanArray,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { copyToArray2j022khrow2yi as copyToArray } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { compactArray1b2nl9rkq8nuz as compactArray } from '../internal/Platform.common.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { toMap1vec9topfei08 as toMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import {
  hashCodeImplfv8qiy3re24s as hashCodeImpl,
  toStringImpl1y3u8fza7vdq as toStringImpl,
} from '../internal/PluginGeneratedSerialDescriptor.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  getChecked1o70dkx10jwym as getChecked,
  getChecked3avs2psuwt1xd as getChecked_0,
} from '../internal/Platform.mjs';
import { contentEqualsaf55p28mnw74 as contentEquals } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import {
  get_isNullable36pbikm8xb7bz as get_isNullable,
  get_isInline5x26qrhi9qs6 as get_isInline,
  SerialDescriptor2pelqekb5ic3a as SerialDescriptor,
} from './SerialDescriptor.mjs';
import { CachedNames2minxlyafeo07 as CachedNames } from '../internal/CachedNames.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function PrimitiveSerialDescriptor(serialName, kind) {
  // Inline function 'kotlin.text.isNotBlank' call
  // Inline function 'kotlin.require' call
  if (!!isBlank(serialName)) {
    var message = 'Blank serial names are prohibited';
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
  }
  return PrimitiveDescriptorSafe(serialName, kind);
}
function buildClassSerialDescriptor(serialName, typeParameters, builderAction) {
  var tmp;
  if (builderAction === VOID) {
    tmp = buildClassSerialDescriptor$lambda;
  } else {
    tmp = builderAction;
  }
  builderAction = tmp;
  // Inline function 'kotlin.text.isNotBlank' call
  // Inline function 'kotlin.require' call
  if (!!isBlank(serialName)) {
    var message = 'Blank serial names are prohibited';
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
  }
  var sdBuilder = new (ClassSerialDescriptorBuilder())(serialName);
  builderAction(sdBuilder);
  return new (SerialDescriptorImpl())(serialName, CLASS_getInstance(), sdBuilder.elementNames_1.get_size_woubt6_k$(), toList(typeParameters), sdBuilder);
}
var ClassSerialDescriptorBuilderClass;
function ClassSerialDescriptorBuilder() {
  if (ClassSerialDescriptorBuilderClass === VOID) {
    class $ {
      constructor(serialName) {
        this.serialName_1 = serialName;
        this.isNullable_1 = false;
        this.annotations_1 = emptyList();
        this.elementNames_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        this.uniqueNames_1 = HashSet().new_kotlin_collections_HashSet_ovxcsm_k$();
        this.elementDescriptors_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        this.elementAnnotations_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        this.elementOptionality_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
      }
      element_om879h_k$(elementName, descriptor, annotations, isOptional) {
        // Inline function 'kotlin.require' call
        if (!this.uniqueNames_1.add_utx5q5_k$(elementName)) {
          var message = "Element with name '" + elementName + "' is already registered in " + this.serialName_1;
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        // Inline function 'kotlin.collections.plusAssign' call
        this.elementNames_1.add_utx5q5_k$(elementName);
        // Inline function 'kotlin.collections.plusAssign' call
        this.elementDescriptors_1.add_utx5q5_k$(descriptor);
        // Inline function 'kotlin.collections.plusAssign' call
        this.elementAnnotations_1.add_utx5q5_k$(annotations);
        // Inline function 'kotlin.collections.plusAssign' call
        this.elementOptionality_1.add_utx5q5_k$(isOptional);
      }
      element$default_ey7ac9_k$(elementName, descriptor, annotations, isOptional, $super) {
        annotations = annotations === VOID ? emptyList() : annotations;
        isOptional = isOptional === VOID ? false : isOptional;
        var tmp;
        if ($super === VOID) {
          this.element_om879h_k$(elementName, descriptor, annotations, isOptional);
          tmp = Unit_instance;
        } else {
          tmp = $super.element_om879h_k$.call(this, elementName, descriptor, annotations, isOptional);
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'ClassSerialDescriptorBuilder');
    ClassSerialDescriptorBuilderClass = $;
  }
  return ClassSerialDescriptorBuilderClass;
}
function SerialDescriptor_0(serialName, original) {
  // Inline function 'kotlin.text.isNotBlank' call
  // Inline function 'kotlin.require' call
  if (!!isBlank(serialName)) {
    var message = 'Blank serial names are prohibited';
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!!(serialName === original.get_serialName_u2rqhk_k$())) {
    var message_0 = 'The name of the wrapped descriptor (' + serialName + ') cannot be the same as the name of the original descriptor (' + original.get_serialName_u2rqhk_k$() + ')';
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_0));
  }
  var tmp = original.get_kind_wop7ml_k$();
  if (tmp instanceof PrimitiveKind()) {
    checkNameIsNotAPrimitive(serialName);
  }
  return new (WrappedSerialDescriptor())(serialName, original);
}
function buildSerialDescriptor(serialName, kind, typeParameters, builder) {
  var tmp;
  if (builder === VOID) {
    tmp = buildSerialDescriptor$lambda;
  } else {
    tmp = builder;
  }
  builder = tmp;
  // Inline function 'kotlin.text.isNotBlank' call
  // Inline function 'kotlin.require' call
  if (!!isBlank(serialName)) {
    var message = 'Blank serial names are prohibited';
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!!equals(kind, CLASS_getInstance())) {
    var message_0 = "For StructureKind.CLASS please use 'buildClassSerialDescriptor' instead";
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_0));
  }
  var sdBuilder = new (ClassSerialDescriptorBuilder())(serialName);
  builder(sdBuilder);
  return new (SerialDescriptorImpl())(serialName, kind, sdBuilder.elementNames_1.get_size_woubt6_k$(), toList(typeParameters), sdBuilder);
}
function _get__hashCode__tgwhef($this) {
  var tmp0 = $this._hashCode$delegate_1;
  var tmp = KProperty1();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('_hashCode', 1, tmp, SerialDescriptorImpl$_get__hashCode_$ref_2v7wzp(), null);
  return tmp0.get_value_j01efc_k$();
}
function SerialDescriptorImpl$_get__hashCode_$ref_2v7wzp() {
  return constructCallableReference((p0) => _get__hashCode__tgwhef(p0), 1, 0, 15);
}
var SerialDescriptorImplClass;
function SerialDescriptorImpl() {
  if (SerialDescriptorImplClass === VOID) {
    class $ {
      constructor(serialName, kind, elementsCount, typeParameters, builder) {
        this.serialName_1 = serialName;
        this.kind_1 = kind;
        this.elementsCount_1 = elementsCount;
        this.annotations_1 = builder.annotations_1;
        this.serialNames_1 = toHashSet(builder.elementNames_1);
        var tmp = this;
        // Inline function 'kotlin.collections.toTypedArray' call
        var this_0 = builder.elementNames_1;
        tmp.elementNames_1 = copyToArray(this_0);
        this.elementDescriptors_1 = compactArray(builder.elementDescriptors_1);
        var tmp_0 = this;
        // Inline function 'kotlin.collections.toTypedArray' call
        var this_1 = builder.elementAnnotations_1;
        tmp_0.elementAnnotations_1 = copyToArray(this_1);
        this.elementOptionality_1 = toBooleanArray(builder.elementOptionality_1);
        var tmp_1 = this;
        // Inline function 'kotlin.collections.map' call
        var this_2 = withIndex(this.elementNames_1);
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_2, 10));
        var _iterator__ex2g4s = this_2.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var item = _iterator__ex2g4s.next_20eer_k$();
          var tmp$ret$4 = to(item.value_1, item.index_1);
          destination.add_utx5q5_k$(tmp$ret$4);
        }
        tmp_1.name2Index_1 = toMap(destination);
        this.typeParametersDescriptors_1 = compactArray(typeParameters);
        var tmp_2 = this;
        tmp_2._hashCode$delegate_1 = lazy(() => hashCodeImpl(this, this.typeParametersDescriptors_1));
      }
      get_serialName_u2rqhk_k$() {
        return this.serialName_1;
      }
      get_kind_wop7ml_k$() {
        return this.kind_1;
      }
      get_elementsCount_288r0x_k$() {
        return this.elementsCount_1;
      }
      get_annotations_20dirp_k$() {
        return this.annotations_1;
      }
      get_serialNames_8zf3cl_k$() {
        return this.serialNames_1;
      }
      getElementName_u4sqmf_k$(index) {
        return getChecked(this.elementNames_1, index);
      }
      getElementIndex_utfbym_k$(name) {
        var tmp0_elvis_lhs = this.name2Index_1.get_wei43m_k$(name);
        return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
      }
      getElementAnnotations_omrjs6_k$(index) {
        return getChecked(this.elementAnnotations_1, index);
      }
      getElementDescriptor_ncda77_k$(index) {
        return getChecked(this.elementDescriptors_1, index);
      }
      isElementOptional_heqq56_k$(index) {
        return getChecked_0(this.elementOptionality_1, index);
      }
      equals(other) {
        var tmp$ret$0;
        $l$block_5: {
          // Inline function 'kotlinx.serialization.internal.equalsImpl' call
          if (this === other) {
            tmp$ret$0 = true;
            break $l$block_5;
          }
          if (!(other instanceof SerialDescriptorImpl())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!(this.get_serialName_u2rqhk_k$() === other.get_serialName_u2rqhk_k$())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!contentEquals(this.typeParametersDescriptors_1, other.typeParametersDescriptors_1)) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!(this.get_elementsCount_288r0x_k$() === other.get_elementsCount_288r0x_k$())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          var inductionVariable = 0;
          var last = this.get_elementsCount_288r0x_k$();
          if (inductionVariable < last)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              if (!(this.getElementDescriptor_ncda77_k$(index).get_serialName_u2rqhk_k$() === other.getElementDescriptor_ncda77_k$(index).get_serialName_u2rqhk_k$())) {
                tmp$ret$0 = false;
                break $l$block_5;
              }
              if (!equals(this.getElementDescriptor_ncda77_k$(index).get_kind_wop7ml_k$(), other.getElementDescriptor_ncda77_k$(index).get_kind_wop7ml_k$())) {
                tmp$ret$0 = false;
                break $l$block_5;
              }
            }
             while (inductionVariable < last);
          tmp$ret$0 = true;
        }
        return tmp$ret$0;
      }
      hashCode() {
        return _get__hashCode__tgwhef(this);
      }
      toString() {
        return toStringImpl(this);
      }
    }
    protoOf($).get_isNullable_67sy7o_k$ = get_isNullable;
    protoOf($).get_isInline_usk17w_k$ = get_isInline;
    initMetadataForClass($, 'SerialDescriptorImpl', VOID, VOID, [SerialDescriptor(), CachedNames()]);
    SerialDescriptorImplClass = $;
  }
  return SerialDescriptorImplClass;
}
var WrappedSerialDescriptorClass;
function WrappedSerialDescriptor() {
  if (WrappedSerialDescriptorClass === VOID) {
    class $ {
      constructor(serialName, original) {
        this.serialName_1 = serialName;
        this.original_1 = original;
      }
      get_serialName_u2rqhk_k$() {
        return this.serialName_1;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof WrappedSerialDescriptor()))
          return false;
        return this.serialName_1 === other.serialName_1 && equals(this.original_1, other.original_1);
      }
      hashCode() {
        var result = getStringHashCode(this.serialName_1);
        result = imul(31, result) + hashCode(this.original_1) | 0;
        return result;
      }
      toString() {
        return toStringImpl(this);
      }
      get_kind_wop7ml_k$() {
        return this.original_1.get_kind_wop7ml_k$();
      }
      get_isNullable_67sy7o_k$() {
        return this.original_1.get_isNullable_67sy7o_k$();
      }
      get_isInline_usk17w_k$() {
        return this.original_1.get_isInline_usk17w_k$();
      }
      get_elementsCount_288r0x_k$() {
        return this.original_1.get_elementsCount_288r0x_k$();
      }
      get_annotations_20dirp_k$() {
        return this.original_1.get_annotations_20dirp_k$();
      }
      getElementName_u4sqmf_k$(index) {
        return this.original_1.getElementName_u4sqmf_k$(index);
      }
      getElementIndex_utfbym_k$(name) {
        return this.original_1.getElementIndex_utfbym_k$(name);
      }
      getElementAnnotations_omrjs6_k$(index) {
        return this.original_1.getElementAnnotations_omrjs6_k$(index);
      }
      getElementDescriptor_ncda77_k$(index) {
        return this.original_1.getElementDescriptor_ncda77_k$(index);
      }
      isElementOptional_heqq56_k$(index) {
        return this.original_1.isElementOptional_heqq56_k$(index);
      }
    }
    initMetadataForClass($, 'WrappedSerialDescriptor', VOID, VOID, [SerialDescriptor()]);
    WrappedSerialDescriptorClass = $;
  }
  return WrappedSerialDescriptorClass;
}
function buildClassSerialDescriptor$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function buildSerialDescriptor$lambda(_this__u8e3s4) {
  return Unit_instance;
}
//region block: exports
export {
  PrimitiveSerialDescriptor as PrimitiveSerialDescriptor3egfp53lutxj2,
  SerialDescriptor_0 as SerialDescriptorbzxbhtn690r4,
  buildClassSerialDescriptor as buildClassSerialDescriptors2a6xdp6mrtw,
  buildSerialDescriptor as buildSerialDescriptor2873qmkp8r2ib,
};
//endregion

//# sourceMappingURL=SerialDescriptors.mjs.map
